import { Component, Input, OnInit } from '@angular/core';
import { Call } from 'src/app/models/call.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-knowledge-base-call-list',
  templateUrl: './knowledge-base-call-list.component.html',
  styleUrls: ['./knowledge-base-call-list.component.scss']
})
export class KnowledgeBaseCallListComponent implements OnInit {
  @Input() calls: Call[];

  public isLoading: boolean = false;

  constructor(
    private router: Router,
    ) {}

  ngOnInit(): void {
  }

  public classesByState(call: Call): string {
    switch (call.status) {
      case 'T': return 'bg-attending';
      case 'P': return 'bg-pending';
      case 'R': return 'bg-solved';
      case 'F': return 'bg-closed';
      case 'C': return 'bg-canceled';
      default: return 'bg-waiting';
    }
  }

  public goToCall(call: Call) {
    this.router.navigate([`/operador/chamados/${ call.identifier }`])
  }

  public getShowName(name): string {
    let user = name.split(' ');
    return user[0]
  }
}
